import getValidationErrors from "@app/util/errorHandling/getValidationErrors";

// mmc-server's deal lock codes: a read-only stage edit or move-in, a create into or delete from a
// locked funnel, and a move in or out of one
const DEAL_LOCK_CODES = new Set(["v1249", "v1250", "v1251", "v1258", "v1259"]);

// For responses that report refusals row by row (bulk saves, Field Agent apply)
export const hasDealLockCode = (errors: ReadonlyArray<{ code?: string }> | undefined): boolean =>
  !!errors?.some(({ code }) => !!code && DEAL_LOCK_CODES.has(code));

const isDealLockRefusal = (error: unknown): boolean => hasDealLockCode(getValidationErrors(error));

export default isDealLockRefusal;
